import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiUserCheck } from 'react-icons/fi';
import AddTalentPage from '../talents/AddTalentPage';

const AddBetaTester = () => {
  const { t } = useTranslation();
  return (
    <AddTalentPage
      category="beta_tester"
      icon={<FiUserCheck />}
      titleKey="website.add_beta_tester.title"
      subKey="website.add_beta_tester.sub"
      listPath="/programmers?tab=beta_tester"
      descriptionLabel={t('website.beta_testers.description_label')}
      descriptionPlaceholder={t('website.beta_testers.description_placeholder')}
    />
  );
};

export default AddBetaTester;
